import React, { useContext, useEffect, useState } from 'react';
import { AppContext, ToastrContext } from '../../contexts';
import { Card, Flex, SimpleGrid, Stack, Text, Title, Transition } from '@mantine/core';
import FilterMerchantForm from '../../components/forms/FilterMerchantForm';
import { useDispatch, useSelector } from 'react-redux';
import MerchantResult from '../../components/fragments/MerchantResult';
import styles from './styles.scoped.css';
import { fetchSearchSettingMerchant, ResetRedux } from '../SettingMerchant/actions';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';
import { RenderModalUpdateFeature } from './Modal';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import IconActivatedUser from '../../components/icons/IconActivatedUser';
import IconBlockUser from '../../components/icons/IconBlockUser';
import { fetchUpdateFeatureStatusMerchant } from './actions';

const MAPFeatureActivation = () => {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const dispatch = useDispatch();
  const { search } = useSelector((s) => s.merchantSetting);
  const [params, setParams] = useState({});

  const history = useNavigate();

  const [modal, setModal] = useState({ type: '', opened: false });
  const handledReset = () => {
    dispatch(ResetRedux());
  };

  const handleSubmit = (value) => {
    dispatch(fetchSearchSettingMerchant(value));
    setParams(value);
  };

  const updateResHandler = (response) => {
    if(response.success){
      setToastr({ desc: 'Berhasil mengubah status aktivasi fitur MAP Pangkalan', type: 'success', visible: true });
      dispatch(fetchSearchSettingMerchant(params));
    }else{
      setToastr({ desc: response.message, type: 'danger', visible: true });
    }
  };

  const handleUpdateFeature = (payload) => {
    const modPayload = {
      userId: search?.data?.userId,
      policy: payload
    };
    dispatch(
      fetchUpdateFeatureStatusMerchant(modPayload, updateResHandler)
    );
    setModal({
      opened: false,
      type: modal.type
    });
  };

  useEffect(() => {
    dispatch(fetchSessionProtection());
    handledReset();
    setBreadcrumbs(['Aktivasi Fitur MAP']);
  }, []);

  return (
    <Stack>
      <Card>
        <Title order={5}>
                Aktifkan dan nonaktifkan fitur MAP dengan file
        </Title>
        <SimpleGrid breakpoints={[
          { minWidth: '48rem', cols: 2, spacing: 24 },
          { maxWidth: '36rem', cols: 1, spacing: 24 },
        ]} cols={2} mt="md" wrap= "wrap">
          <Card w="100%" withBorder>
            <Title fz={18} order={6}>
                    Aktifkan Fitur MAP Pangkalan
            </Title>
            <Text c="#52575C" mb={16} mt={6}>
                Unggah file yang akan diaktifkan fitur MAP
            </Text>
            <Button className={styles.cusBtn} fullWidth={false} icon={<IconActivatedUser/>} onClick={() => history('/activation-feature-map/bulk/activation')} outlined>Unggah File Daftar Pangkalan</Button>
          </Card>
          <Card w="100%" withBorder>
            <Title fz={18} order={6}>
                    Nonaktifkan Fitur MAP Pangkalan
            </Title>
            <Text c="#52575C" mb={16} mt={6}>
                Unggah file yang akan dinonaktifkan fitur MAP
            </Text>
            <Button className={styles.cusBtn} icon={<IconBlockUser/>} onClick={() => history('/activation-feature-map/bulk/inactivation')} outlined style="danger">Unggah File Daftar Pangkalan</Button>
          </Card>
        </SimpleGrid>
      </Card>
      <Card className={styles.cardSearch}>
        <Flex align="center" >
          <div>
            <img
              height="100"
              src="/assets/illu-setting-merchant.svg"
              width="100"
            />
          </div>
          <div>
            <Title order={4}>Cari data pangkalan</Title>
            <Text c="#52575C">Cari data pangkalan untuk melakukan aktivasi fitur MAP</Text>
            <FilterMerchantForm
              code={search?.code}
              handledReset={handledReset}
              handleSubmitMerchant={handleSubmit}
              message={search?.message}
            />
          </div>
        </Flex>
        <Transition  duration={400} mounted={search?.data && true} timingFunction="ease" transition="fade">
          {(style) => (
            <div style={style}><MerchantResult data={search?.data} onClick={() => setModal({ opened: true, type: 'modalUpdate' })}/></div>
          )}
        </Transition>
      </Card>
      {modal.type === 'modalUpdate' && <RenderModalUpdateFeature data={search?.data} onConfirm={handleUpdateFeature} opened={modal.opened} setModal={setModal} />}
    </Stack>
  );
};

export default MAPFeatureActivation;
